import { useStore } from '@/store'

export default {
  install(Vue) {
    const havePagePermission = (page) => {
      const mainUseStore = useStore()
      if (!page) return true
      if (!Vue.isLogged()) return false

      const permissions = mainUseStore.userPermissions
      if (permissions && permissions[0] === 'mf/admin') return true

      return permissions && permissions.includes(page)
    }

    const haveParentPermission = (parent) => {
      const mainUseStore = useStore()
      if (!parent) return true
      if (!Vue.isLogged()) return false

      const permissions = mainUseStore.userPermissions
      if (permissions && permissions[0] === 'mf/admin') {
        return true
      } else {
        return permissions.find((permission) => permission.split('/')[0] === parent)
      }
    }

    Vue.prototype.$havePagePermission = Vue.havePagePermission = havePagePermission
    Vue.prototype.$haveParentPermission = Vue.haveParentPermission = haveParentPermission

    Object.defineProperty(Vue.prototype, '$permissions', {
      get: () => ({
        havePagePermission,
        haveParentPermission,
      }),
    })

    Object.defineProperty(Vue, 'permissions', {
      get: () => {
        return {
          havePagePermission,
          haveParentPermission,
        }
      },
    })
  },
}
